/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use <CompanySelect /> instead
 */
import { Color, Text } from '@billy/design-system'
import { useCallback, useState } from 'react'
import { Control } from 'react-hook-form'

import { Select, SelectItem, SelectProps } from '../../../../components-deprecated/Select'
import { useLocale } from '../../../../hooks/useLocale'
import { deprecatedComponentInfo } from '../../../../utils/deprecatedComponentInfo'
import { getItemsForSelect } from '../../../../utils/forms'
import { getApiCountryKey } from '../../../../utils/getApiCountryKey'
import { useUserOrganization } from '../../organization'
import { useFetchCompanies } from '../hooks/useFetchCompanies'
import { Company } from '../types'
import { getCompanyName } from '../utils/getCompanyName'

deprecatedComponentInfo('CompanySelector', 'CompanySelect')

export type CompanySelectorProps = Omit<SelectProps<Company>, 'type' | 'onBlur' | 'onFocus'> & {
  error?: string
  formControl?: Control<any>
  name: string
  onItemSelect?: (company: Company, name?: string) => void
  onTextChange?: (text: string) => void
  required?: boolean
  selectedItem?: SelectItem & Company
  displayProp?: keyof Company
}

// For NL we show basic address (without number and zipcode) in the selector list
// https://linear.app/ageras-new/issue/BOOK-1574/extend-company-registration-number-lookup-to-netherlands
const getBasicCompanyAddress = (company: Company) => `${company.street}, ${company.city}`

const getCompanyAddress = (company: Company) =>
  company.numberTo
    ? `${company.street} ${company.number} - ${company.numberTo}`
    : `${company.street} ${company.number}, ${company.zipcode} ${company.city}`

const CompanyMenuItem = (company: Company, active: boolean, apiCountryKey: string) => (
  <>
    <Text
      weight="medium"
      color={active ? Color.Grey950 : undefined}
    >{`${getCompanyName(company) ?? ''} - ${company.id}`}</Text>
    <Text variant="bodySM" color={active ? Color.Grey950 : Color.Grey500}>
      {apiCountryKey === 'nl' ? getBasicCompanyAddress(company) : getCompanyAddress(company)}
    </Text>
  </>
)

export const CompanySelector = ({
  error,
  formControl,
  label,
  name,
  onItemSelect = () => null,
  onTextChange = () => null,
  required,
  selectedItem,
  displayProp,
  ...rest
}: CompanySelectorProps) => {
  const { organization } = useUserOrganization()
  const { code: language } = useLocale()
  const apiCountryKey = getApiCountryKey(organization?.countryId, language)

  const [value, setValue] = useState('')
  const { companies } = useFetchCompanies(value)

  const items = getItemsForSelect<Company>(companies, displayProp)

  const handleTextChange = useCallback(
    (text: string) => {
      setValue(text || '')
      onTextChange && onTextChange(text)
    },
    [onTextChange],
  )

  return (
    <Select<Company>
      formControl={formControl}
      items={items}
      name={name}
      label={label}
      required={required}
      error={error}
      errorPath={name}
      selectedItem={selectedItem}
      render={(company: Company, active: boolean) => CompanyMenuItem(company, active, apiCountryKey)}
      onTextChange={handleTextChange}
      onItemSelect={(item: object) => onItemSelect(item as Company, name)}
      icon="search"
      value={value}
      {...rest}
    />
  )
}
